(function () {
    "use strict";
    realmCommerceApp.factory("errorsService", ErrorsService);

    /*@ngInject*/
    function ErrorsService($log) {

        var service = {
            errorCallback: errorCallback
        };

        return service;

        function errorCallback(message) {
            $log.log(message);
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/services/errors.service.js